var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breadcrumbs.length > 1)?_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs,"large":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('router-breadcrumb',{attrs:{"route":item}})]}},{key:"divider",fn:function(){return [_c('base-icon',{attrs:{"name":"chevron-right"}})]},proxy:true}],null,false,3772390145)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }